import { combineReducers } from 'redux';
import authUser from './authUser';
import appShell from './appShell';
import employees from './employees';
import users from './users';
import dashboard from './dashboard';
import employeeDetails from './employeeDetailPages/details';
import employeeMoveDetails from './employeeDetailPages/move';
import ticketRequestDetails from './employeeDetailPages/ticket';
import shortStayRequestDetails from './employeeDetailPages/shortStay';
import airportTransferRequestDetails from './employeeDetailPages/airportTransfer';
import bulkUploadDetails from './employeeDetailPages/upload';
import userViews from './userViews';

const reducersList = combineReducers({
  authUser,
  appShell,
  employees,
  users,
  dashboard,
  employeeDetails,
  employeeMoveDetails,
  ticketRequestDetails,
  shortStayRequestDetails,
  airportTransferRequestDetails,
  userViews,
  bulkUploadDetails,
});
export default reducersList;
